import classNames from "classnames";
import HorizontalHIDLayoutHoc from "@components/hocs/HorizontalHIDLayoutHoc";
import { Expert } from "@models/Expert";

interface ISimpleExpertDetailCard {
  expert: Expert;
  className?: string;
}

const SimpleExpertDetailCard = (props: ISimpleExpertDetailCard) => {
  const { expert, className } = props,
    classes = classNames("simple-expert-detail-card", className);

  return (
    <div className={classes}>
      <HorizontalHIDLayoutHoc
        header={
          <div className="sed-header">
            <h2 className="title">
              <span className="first-name">{expert.firstName}</span>
              {expert.lastName ? (
                <>
                  <span>&nbsp;</span>
                  <span className="last-name">{expert.lastName}</span>
                </>
              ) : (
                <></>
              )}
              {expert.credentials?.length ? (
                <>
                  <span>,&nbsp;</span>
                  <span className="credentials">{expert.credentials.join(", ")}</span>
                </>
              ) : (
                <></>
              )}
            </h2>
            {expert.position ? <p className="position">{expert.position}</p> : <></>}
          </div>
        }
        image={<img className="avatar" src={expert.image?.src || ""} loading="lazy" width={300} height={311} alt={expert.slug} />}
      >
        {expert.affiliations?.length ? (
          <div className="affiliations">
            <label>Professional Affiliations</label>
            {expert.affiliations.map((affiliate, idx) => (
              <p key={idx}>{affiliate}</p>
            ))}
          </div>
        ) : (
          <></>
        )}

        {expert.contact ? (
          <div className="contacts">
            <label>Contact Information</label>
            {expert.contact.phone ? (
              <p>
                Phone Number: <a href={`tel:${expert.contact.phone}`}>{expert.contact.phone}</a>
              </p>
            ) : (
              <></>
            )}
            {expert.contact.fax ? (
              <p>
                Fax Number: <a href={`tel:${expert.contact.fax}`}>{expert.contact.fax}</a>
              </p>
            ) : (
              <></>
            )}
            {expert.contact.email ? (
              <p>
                Email: <a href={`mailto:${expert.contact.email}`}>{expert.contact.email}</a>
              </p>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}

        <div className="socials">
          {expert.linkedinUrl ? (
            <a className="link social-link" href={expert.linkedinUrl} rel="noopener noreferrer" target="_blank">
              LinkedIn
            </a>
          ) : (
            <></>
          )}
        </div>
      </HorizontalHIDLayoutHoc>
    </div>
  );
};

export default SimpleExpertDetailCard;
